const Disciplines = {
    SLALOM: 'SLALOM',
    GIANT_SLALOM: 'GIANT_SLALOM',
    SUPER_G: 'SUPER_G',
    DOWNHILL: 'DOWNHILL',
    PARALLEL_GIANT_SLALOM: 'PARALLEL_GIANT_SLALOM'
}

export default Disciplines;
